import { LandingPage } from 'components/desktop/pages/Landing';

export default LandingPage;
